import SidebarLogo from "./SidebarLogo";
// import SidebarTopClinic from "./SidebarTopClinic";
import SidebarMenu from "./SidebarMenu";

export default function Sidebar({
  SideBar,
  OpenMenu,
  toggleMenuSidebar,
  HideWeb,
  toggleWebMenu,
}) {
  return (
    <div
      className={`sidebar ${OpenMenu == true ? "show-sidebar" : ""}`}
      id="sidebar"
    >
      <SidebarLogo
        toggleMenuSidebar={toggleMenuSidebar}
        toggleWebMenu={toggleWebMenu}
        HideWeb={HideWeb}
      />
      <div className="sidebar-inner" data-simplebar>
        <div id="sidebar-menu" className="sidebar-menu">
          {/* <SidebarTopClinic /> */}
          <SidebarMenu
            SideBar={SideBar}
            HideWeb={HideWeb}
            toggleWebMenu={toggleWebMenu}
          />
        </div>
      </div>
    </div>
  );
}
